//https://debankglobal.larksuite.com/wiki/Fs7VwYPZzi6rCbkNtb3uwEX7sJh
import { useMutation, useQuery } from 'react-query';

import { queryClient, request, toastError, toastSuccess, useCurrentUserId } from '@/utils';

import { UserXP } from '../types';
import { invalidXPRecordList } from './record';

const QUERY_USER_XP_URL = '/user/xp';

export const useUserXP = () => {
  const userId = useCurrentUserId();

  return useQuery(
    [QUERY_USER_XP_URL, userId],
    () => {
      return request
        .get<{
          xp: UserXP;
        }>(QUERY_USER_XP_URL)
        .then(x => x.xp);
    },
    {
      enabled: !!userId,
    },
  );
};

const invalidUserXp = (userId?: string) => {
  queryClient.invalidateQueries([QUERY_USER_XP_URL, userId]);
};

const INITIAL_XP_CLAIM_CHECK_URL = '/xp/check_init_claim';

// 用户没有快照积分，全部返回 0
export const useInitialXPClaimCheck = () => {
  const userId = useCurrentUserId();

  return useQuery([INITIAL_XP_CLAIM_CHECK_URL, userId], () => {
    return request.get<{
      net_worth_xp: number;
      credit_score_xp: number;
      social_ranking_xp: number;
      total_xp: number;
      is_claimed: boolean;
    }>(INITIAL_XP_CLAIM_CHECK_URL);
  });
};

// 领取快照积分
export const useInitialXPClaim = () => {
  const userId = useCurrentUserId();

  return useMutation(
    (referer_code?: string) => {
      return request.post<{ is_success: boolean }>('/xp/claim_init_xp', {
        referer_code: referer_code || '',
      });
    },
    {
      onSuccess: res => {
        if (!res?.is_success) {
          toastError(res);
        }

        queryClient.invalidateQueries([INITIAL_XP_CLAIM_CHECK_URL, userId]);
        invalidUserXp(userId);
        invalidXPRecordList(userId);
        toastSuccess('Claimed');
      },
      onError: toastError,
    },
  );
};
